<template>
<!--  <p class="open-sans-font custom-span-contact position-relative">-->
<!--    <i class="fa fa-map position-absolute"></i>-->
<!--    <span class="d-block">Address Point</span>123 Stree New York City , United-->
<!--    States Of America 750065.-->
<!--  </p>-->
  <!-- {/* End .custom-span-contact */} -->

  <p class="open-sans-font custom-span-contact position-relative">
    <i class="fa fa-envelope-open position-absolute"></i>
    <span class="d-block">napisz do mnie</span>
    <a href="mailto:steve@mail.com">lukasz@maslag.com</a>
  </p>
  <!-- {/* End .custom-span-contact */} -->

  <p class="open-sans-font custom-span-contact position-relative">
    <i class="fa fa-phone-square position-absolute"></i>
    <span class="d-block">zadzowń</span>
    <a href="Tel: +216 21 184 010">512-803-134</a>
  </p>
  <!-- {/* End .custom-span-contact */} -->
</template>

<script>
export default {};
</script>
